import LoadingButton from '@mui/lab/LoadingButton';
import { Button, styled } from '@mui/material';
import { Colors } from '../../constants/color';

const CustomisedButton = styled(Button)({
  textTransform: 'none',
  backgroundColor: Colors.secondary,
  height: '6vh',
  borderRadius: '5px',
  justifyContent: 'flex-start',
  paddingLeft: '40px',
  '&:hover': {
    backgroundColor: Colors.secondary,
  },
});

const CustomisedIconButton = styled(Button)({
  height: '32.26px',
  width: 'fit-content',
  backgroundColor: '#fffff',
  borderRadius: '8px',
  color: Colors.pageHeading_icon,
  border: '1px solid #E2E2EA',
});

const CustomisedSaveButton = styled(Button)({
  height: '39px',
  paddingInline: '10px',
  boxSizing: 'border-box',
  borderRadius: '8px',
  backgroundColor: Colors.secondary,
  textTransform: 'none',
  color: 'white',
  gap: '4px',
  fontSize: '16px',
  '&:hover': {
    backgroundColor: Colors.secondary,
  },
  '&:disabled': { background: Colors.lightText, color: 'white' },
});

const CustomisedLoadingButton = styled(LoadingButton)({
  height: '39px',
  paddingInline: '10px',
  boxSizing: 'border-box',
  borderRadius: '8px',
  backgroundColor: Colors.secondary,
  textTransform: 'none',
  color: 'white',
  gap: '4px',
  fontSize: '16px',
  '&:hover': {
    backgroundColor: Colors.secondary,
  },
  '&:disabled': { background: Colors.lightText, color: 'white' },
});
const CustomisedUploadButton = styled(Button)({
  backgroundColor: 'white',
  color: Colors.pageHeading_icon,
  borderRadius: '8px',
});
const CustomisedDeleteButton = styled(Button)({
  height: '39px',
  padding: '0px 20px',
  borderRadius: '8px',
  backgroundColor: 'red',
  color: 'white',
  marginRight: '10px',
  fontSize: '14px',
  '&:hover': {
    backgroundColor: '#D10000',
  },
});
const CustomisedSettingsDeleteButton = styled(Button)({
  height: '42px',
  borderRadius: '8px',
  backgroundColor: 'red ',
  border: '1px solid red',
  color: 'white',
  fontSize: '14px',
  textTransform: 'none',
  paddingInline: '15px',
  '&:hover': {
    backgroundColor: '#D10000',
    border: 'none',
    color: 'white',
  },
});
const CustomisedSettingsLightModeDeleteButton = styled(Button)({
  height: '42px',
  borderRadius: '8px',
  backgroundColor: 'white ',
  border: '1px solid red',
  color: 'red',
  fontSize: '14px',
  textTransform: 'none',
  paddingInline: '15px',
  '&:hover': {
    border: '2px solid red',
  },
});
const CustomisedLightModeDeleteButton = styled(Button)({
  height: '39px',
  padding: '0px 20px',
  borderRadius: '8px',
  backgroundColor: 'white',
  border: '1px solid red',
  color: 'red',
  marginRight: '10px',
  fontSize: '14px',
  '&:hover': {
    border: '2px solid red',
  },
});
export {
  CustomisedButton,
  CustomisedIconButton,
  CustomisedSaveButton,
  CustomisedUploadButton,
  CustomisedDeleteButton,
  CustomisedSettingsDeleteButton,
  CustomisedSettingsLightModeDeleteButton,
  CustomisedLightModeDeleteButton,
  CustomisedLoadingButton,
};
